import { render, staticRenderFns } from "./AddTaxProfile.vue?vue&type=template&id=4e6d4b5a"
import script from "./AddTaxProfile.vue?vue&type=script&lang=js"
export * from "./AddTaxProfile.vue?vue&type=script&lang=js"
import style0 from "./AddTaxProfile.vue?vue&type=style&index=0&id=4e6d4b5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports